import forwardIconEN from "./w-letter.png";
import forwardIconFR from "./w-letter-fr.png";
import backIconEN from "./s-letter.png";
import backIconFR from "./s-letter-fr.png";

import leftIconEN from "./a-letter.png";
import leftIconFR from "./a-letter-fr.png";

import rightIconEN from "./d-letter.png";
import rightIconFR from "./d-letter-fr.png";

import upIconEN from "./space.png";
import upIconFR from "./space-fr.png";

import leftMouseEN from "./left-mouse.svg";
import leftMouseFR from "./left-mouse-fr.svg";

import captionIconEN from "./k-letter.png";
import captionIconFR from "./k-letter-fr.png";

import buttonIconEN from "./button.png";
import buttonIconFR from "./button-fr.png";

import enterIconEN from "./enter.png";
import enterIconFR from "./enter-fr.png";

import instructionImageEN from "./../assets/instruction.png";
import instructionImageFR from "./../assets/instruction-fr.png";


export const assets = {
  "en-US": {
    forwardIcon: forwardIconEN,
    backIcon: backIconEN,
    leftIcon: leftIconEN,
    rightIcon: rightIconEN,
    upIcon: upIconEN,
    leftMouse: leftMouseEN,
    captionIcon: captionIconEN,
    buttonIcon: buttonIconEN,
    enterIcon: enterIconEN,
    instructionImage: instructionImageEN,
  },
  "fr-CA": {
    forwardIcon: forwardIconFR,
    backIcon: backIconFR,
    leftIcon: leftIconFR,
    rightIcon: rightIconFR,
    upIcon: upIconFR,
    leftMouse: leftMouseFR,
    captionIcon: captionIconFR,
    buttonIcon: buttonIconFR,
    enterIcon: enterIconFR,
    instructionImage: instructionImageFR,
  },
};
